import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';

const RemoveSectionDialog = ({ open, handleClose, handleRemoveAndClose }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogContent>
        <DialogContentText id="alert-dialog-description">آیا از حدف این سانس اطمینان دارید ؟</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleRemoveAndClose} color="primary">
          تایید
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveSectionDialog;
